import { apiFetch } from '@/shared/api/client'

export type ApiOutlet = {
  id: string
  code: string
  name: string
}

export type ApiDelman = {
  id: string
  name: string
}

export async function fetchKitchenOutlets(deviceId: string): Promise<ApiOutlet[]> {
  const encoded = encodeURIComponent(deviceId)
  const res = await apiFetch<{ outlets: ApiOutlet[] }>(`/kitchen/outlets?device_id=${encoded}`)
  return res.outlets ?? []
}

export async function fetchKitchenDelmans(deviceId: string): Promise<ApiDelman[]> {
  const encoded = encodeURIComponent(deviceId)
  const res = await apiFetch<{ delmans: ApiDelman[] }>(`/kitchen/delmans?device_id=${encoded}`)
  return res.delmans ?? []
}

export type ApiStockItem = {
  productName: string
  productionDate: string
  stockAvailable: number
  categoryName?: string
  categorySortOrder?: number
}

export async function fetchKitchenStock(deviceId: string): Promise<ApiStockItem[]> {
  const encoded = encodeURIComponent(deviceId)
  const res = await apiFetch<{ stock: ApiStockItem[] }>(`/kitchen/stock?device_id=${encoded}`)
  return res.stock ?? []
}

export async function fetchKitchenStockLots(deviceId: string): Promise<ApiStockItem[]> {
  const encoded = encodeURIComponent(deviceId)
  const res = await apiFetch<{ stock: ApiStockItem[] }>(
    `/kitchen/stock?device_id=${encoded}&granularity=lot`,
  )
  return res.stock ?? []
}

/** Stok waste dapur (lokasi kitchen_return_area): retur toko + good di-regrade. */
export async function fetchKitchenWasteStock(deviceId: string): Promise<ApiStockItem[]> {
  const encoded = encodeURIComponent(deviceId)
  const res = await apiFetch<{ stock: ApiStockItem[] }>(`/kitchen/waste-stock?device_id=${encoded}`)
  return res.stock ?? []
}

export async function fetchKitchenWasteStockLots(deviceId: string): Promise<ApiStockItem[]> {
  const encoded = encodeURIComponent(deviceId)
  const res = await apiFetch<{ stock: ApiStockItem[] }>(
    `/kitchen/waste-stock?device_id=${encoded}&granularity=lot`,
  )
  return res.stock ?? []
}

export type ApiOutletPlanLine = {
  productName: string
  planQty: number
}

export async function fetchOutletPlan(
  deviceId: string,
  outletId: string,
  planDate?: string,
): Promise<ApiOutletPlanLine[]> {
  const device = encodeURIComponent(deviceId)
  const outlet = encodeURIComponent(outletId)
  const dateQuery = planDate ? `&plan_date=${encodeURIComponent(planDate)}` : ''
  const res = await apiFetch<{ lines: ApiOutletPlanLine[] }>(
    `/kitchen/outlet-plan?device_id=${device}&outlet_id=${outlet}${dateQuery}`,
  )
  return res.lines ?? []
}
